<app-background-image data-state="sustainability"></app-background-image>
<app-topbar></app-topbar>


<app-sidebar class="d-print-none">
    <div class="sidebar-header"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button class="btn btn-outline-primary btn-block" (click)="back()">
                <fa-icon [icon]="faBack"></fa-icon>
                <span style="padding-left: 10px">Back</span>
            </button>
        </li>
    </ul>
</app-sidebar>
<ng-container>
    <div class="main-content">
    <form (ngSubmit)="onDisclaimerSubmit()" autocomplete="off" class="form-disclaimer">
        <app-card headline="Edit Disclaimer">
            <app-card-body>
                <table class="form-table" [formGroup]="editDisclaimerFormGroup">
                    <tbody>
                        <tr>
                            <td>
                                <label for="disclaimer">Disclaimer<span>*</span></label>
                            </td>
                            <td>
                                <textarea id="disclaimer" rows="5" formControlName="disclaimer" class="form-control" [ngClass]="{'is-invalid': (disclaimerControl.touched || disclaimerControl.dirty) && !disclaimerControl.valid, 'is-valid': disclaimerControl.valid}"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </app-card-body>
            <app-card-footer>
                <div class="btn-group float-right">
                    <button class="btn btn-primary" [disabled]="!editDisclaimerFormGroup.valid">Update</button>
                </div>
            </app-card-footer>
        </app-card>
    </form>
    </div>
</ng-container>
